import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import ProfileHeader from "../ProfileHeader";
import axios from "axios";
import { ProfileSectionType } from "../ProfileSections";
import Events from "../../Events/Events";
import PhotoLibrary from "../../PhotoLibrary.tsx/PhotoLibrary";
import SlotPicker from "../../Booking/SlotPicker";
interface ProfileAccountProps {
  accountId: number;
  username: string;
}

interface AccountProfile {
  account_id: number;
  account: string;
  address: string;
  city: string;
  county_id: number;
  county_json: any;
  county_name: string;
  state_code: string;
  state_name: string;
  zip: string;
  account_avatar_url: string;
  owner_id: number;
  owner_name: string;
  owner_avatar_url: string;
  account_created_at: string;
  account_updated_at: string;
}

const ProfileAccount: React.FC<ProfileAccountProps> = ({
  accountId,
  username,
}) => {
  const [accountProfile, setAccountProfile] = useState<AccountProfile | null>(
    null
  );
  const [currentSection, setCurrentSection] =
    useState<ProfileSectionType>("Events");

  useEffect(() => {
    if (accountId) {
      loadAccountProfile();
    }
  }, [accountId]);

  const loadAccountProfile = async () => {
    try {
      const response = await axios.get<AccountProfile>(
        `${import.meta.env.VITE_API_URL}/accounts/account-profile/${accountId}`
      );
      setAccountProfile(response.data);
    } catch (error) {
      console.error("Error fetching account profile:", error);
    }
  };

  const formatAddress = (profile: AccountProfile) => {
    return `${profile.address}, ${profile.city}, ${profile.state_code} ${profile.zip}`;
  };

  const renderSection = () => {
    switch (currentSection) {
      case "Events":
        return (
          <Grid item xs={12}>
            <Events
              profileView={{
                type: "Account",
                id: accountId,
              }}
            />
          </Grid>
        );
      case "Availability":
        return (
          <Grid item xs={12}>
            <SlotPicker />
          </Grid>
        );
      case "Photos":
        return (
          <Grid item xs={12}>
            <PhotoLibrary username={username} />
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {accountProfile && (
            <ProfileHeader
              name={accountProfile.account}
              avatar={accountProfile.account_avatar_url}
              subtext={formatAddress(accountProfile)}
              showRatings={false}
              userId={accountId}
              userType="Account"
              currentSection={currentSection}
              onSectionChange={setCurrentSection}
            />
          )}
        </Grid>
        {renderSection()}
      </Grid>
    </Container>
  );
};

export default ProfileAccount;
